import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=36c83ebe&scoped=true&"
var script = {}
import style0 from "./notifications.vue?vue&type=style&index=0&id=36c83ebe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c83ebe",
  null
  
)

export default component.exports